import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loading } from '@vnetwork/ui/feedback';
import { useAuth } from '@/auth/AuthProvider';

/**
 * Gate for authenticated routes. While the session is resolving we show a
 * spinner; unauthenticated users are bounced to /auth/login with the intended
 * path preserved in `state.from` so the callback can send them back.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <Loading fullscreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
